import { ApplicationStatus } from '@/CandidateExperience/constants/applicationStatus'

export const applicationStatusLabel = {
  [ApplicationStatus.Accepted]: 'Accepted',
  [ApplicationStatus.Pending]: 'Pending',
  [ApplicationStatus.Declined]: 'Declined',
  [ApplicationStatus.Expired]: 'Expired',
  [ApplicationStatus.PositionClosed]: 'No longer hiring',
  [ApplicationStatus.CandidatePlaced]: 'Withdrawn',
}

export const applicationStatusTheme = {
  [ApplicationStatus.Accepted]: 'success',
  [ApplicationStatus.Pending]: 'dark',
  [ApplicationStatus.Declined]: 'error',
  [ApplicationStatus.Expired]: 'warning',
  [ApplicationStatus.PositionClosed]: 'warning',
  [ApplicationStatus.CandidatePlaced]: 'warning',
}
